<template>
  <div class="nav-top-menu bg-clomos gradient-background__noise">
    <!-- Logo -->
    <div class='top-menu-logo me-5'></div>

    <div class="m-auto ms-0 me-0 pe-3"
      style="scrollbar-width: thin;scrollbar-color: #0d48a4 #ECECEC; overflow-x: auto;overflow-y: hidden;">
      <AvailableMenuComponent :session="session" :dictionary="dictionary" :visibility="visibility"
        :availableModules="session.authorisation.availableModules"
        v-on:onAvailableMenuItemClicked="onAvailableMenuItemClicked" v-on:logOutRequest="logOutRequest">
      </AvailableMenuComponent>
    </div>

    <!-- Menu lateral -->
    <div class="top-menu-side-menu-toggle">
  <div class="d-flex align-items-center language">
    <!-- Imagen que se ocultará en móviles -->
    <img title="D&A innovative-systems" src="@/assets/img/clomos.png" class="img-fluid m-auto mt-2 c-pointer desktop-only"
      style="max-width: 150px;">

    <!-- Icono de ayuda y texto -->
    <ion-icon name="help-circle-outline" class="tx-26 tx-white mobile-icon desktop-only" @click="toggleDropdown"></ion-icon>
    <span class="text-start text-white tx-25 text-uppercase p-1 mobile-text" @click="toggleDropdown">
      {{ dictionary['Ayuda'][session.user.language] }}
    </span>
  </div>
  <div class="position-relative">
    <!-- Menú desplegable -->
    <ul v-if="showDropdown" class="dropdown-menu dropdown-menu-start show position-absolute mt-4"
      style="left: -90px; top: 13px;">
      <li>
        <a class="dropdown-item d-flex align-items-center" @click="openWebLink('web')" target="_blank">
          <ion-icon id="home" name="laptop-outline" class="tx-18 pe-1 tx-black"></ion-icon>
          Web
        </a>
      </li>
      <li>
        <a class="dropdown-item d-flex align-items-center" @click="openWebLink('locker')" target="_blank">
          <ion-icon id="home" name="file-tray-stacked-outline" class="tx-18 pe-1 tx-black"></ion-icon>
          {{ dictionary['Locker'][session.user.language] }}
        </a>
      </li>
    </ul>
    <!-- Icono del menú -->
    <ion-icon name="menu" id="toggleSideMenuButton" class="top-menu-icon tx-white ms-3 mt-2 mobile-icon" style="font-size: 25px"
      @click="$emit('toggleSideMenu')"></ion-icon>
  </div>
</div>

  </div>
</template>

<script>
import AvailableMenuComponent from '@/components/navigation/AvailableMenuComponent';

export default {
  name: "TopMenuComponent",
  components: { AvailableMenuComponent },
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    visibility: {
      type: Object,
      required: true,
    },
    currentCompany: {
      type: Object,
      required: true,
    }
  },
  watch: {
    currentCompany: function () {
      if ((this.userCompany.name === undefined && this.currentCompany.name != undefined)
        || (this.userCompany.name === undefined && this.currentCompany.name != undefined)
        || (this.userCompany.name != this.currentCompany.name)) {
        this.userCompany.name = this.currentCompany.name;
        this.userCompany.nifCif = this.currentCompany.nifCif;
      }
    }
  },
  emits: ["setCurrentCompany", "getCurrentCompanyData", "toggleSideMenu", "logOutRequest"],
  data() {
    return {
      userCompany: {},
      redirectModules: ['electricalMonitoring'],
      showDropdown: false,
    }
  },
  methods: {
    openWebLink(mode) {
      let url;
      if (mode === "locker") {
        url = '/app/pantalla_es.html'
      } else {
        url = '/app/web_es.html'
      }
      window.open(url, '_blank');
      this.showDropdown = !this.showDropdown;
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    // NAVIGATE 
    onAvailableMenuItemClicked() {
      if (this.visibility.sideMenu) this.$emit('toggleSideMenu');
    },
    // LOG OUT
    logOutRequest() {
      this.$emit('logOutRequest');
    },
    redirect() {
      try {
        switch (true) {
          case this.$route.params.currentModule.includes("smartLockers"):
            return 1;
          case this.$route.params.currentModule.includes("devices"):
            return 2;

          case this.$route.params.currentModule.includes("fabric"):
            return 1;
          case this.$route.params.currentModule.includes("electricalMonitoring"):
            return window.open("/ayuda_aviles/MANUAL-USUARIO.html", "_blank");

          default:
            return null;
        }
      } catch (error) {
        console.error("Error parsing URL:", error);
        return null;
      }

    }
  }
}
</script>

<style>
.nav-top-menu {
  height: 4.5rem;
  width: 100%;
  color: #FFF;
  border-bottom: solid 0.5px rgba(255, 255, 255, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  font-weight: 400;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.top-menu-icon:hover {
  cursor: pointer;
  opacity: 0.75;
  transition: all 0.3s;
}

.top-menu-logo {
  background-image: url("@/assets/img/logo.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position-y: center;
  cursor: pointer;
  width: 13rem;
  min-width: 17rem;
  height: 70%;
  padding: 0;
  margin: auto 1rem auto 1rem;
  transition: all 0.3s;
  filter: brightness(0) invert(1);
}

@media (max-width: 767px) {
  .top-menu-logo {
    background-image: url("@/assets/img/logo.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position-y: center;
    cursor: pointer;
    width: 4.1rem;
    min-width: 4.1rem;
    height: 70%;
    padding: 0;
    margin: auto 1rem auto 1rem;
    transition: all 0.3s;
    filter: brightness(0) invert(1);
  }
}

.top-menu-side-menu-toggle {
  display: flex;
  justify-content: center;
  align-self: center;
  margin-left: auto;
  margin-right: 1.25rem;
  transition: all 0.3s;
}

.top-menu-selector {
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 200px;
  min-width: 200px;
  margin-right: 1.25rem;
  transition: all 0.3s;
}

.top-menu-warnings {
  display: flex;
  justify-content: center;
  float: left;
  align-self: center;
  margin-left: auto;
  margin-right: 1.25rem;
  transition: all 0.3s;
}

.top-menu-profile-button {
  display: flex;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border: solid 1px white;
  border-radius: 3rem;
  transition: all 0.3s;
}

.f-modal-alert {
  background-color: transparent;
  margin: 20px;
  padding: 0px;
  padding-top: 0px;
  width: 60px;
}

/* Estilos para móviles */
@media (max-width: 767.98px) {
  .desktop-only {
    display: none; /* Oculta la imagen en móviles */
  }

  .mobile-icon {
    margin-right: 8px; /* Reduce la distancia entre el icono de ayuda y el icono del menú */
  }

  .mobile-text {
    font-size: 20px; /* Ajusta el tamaño del texto si es necesario */
  }
}

/* Estilos para escritorio */
@media (min-width: 768px) {
  .desktop-only {
    display: block; /* Muestra la imagen en escritorio */
  }

  .mobile-icon {
    margin-right: 16px; /* Distancia normal en escritorio */
  }

  .mobile-text {
    font-size: 25px; /* Tamaño normal del texto en escritorio */
  }
}
</style>